import { useMemo } from "react";
import { ThemeEditor } from "@wedding/theme-editor";
import { useWedding } from "../contexts/wedding-context";
import { createAdminJoinThemeApi } from "../lib/api";

/**
 * Admin adapter for the shared join-theme editor (per-wedding). Same UI as the
 * organizer — the single source of truth lives in `@wedding/theme-editor`; only
 * the API client (admin auth) + wedding context differ. Distinct from the global
 * `/themes` page (platform default backgrounds).
 */
export function WeddingThemesPage() {
  const { wedding, slug, refresh } = useWedding();
  const api = useMemo(() => createAdminJoinThemeApi(slug), [slug]);
  return <ThemeEditor slug={slug} wedding={wedding} refresh={refresh} api={api} />;
}
